import { render, staticRenderFns } from "./star-display.vue?vue&type=template&id=14792344&"
import script from "./star-display.vue?vue&type=script&lang=js&"
export * from "./star-display.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14792344')) {
      api.createRecord('14792344', component.options)
    } else {
      api.reload('14792344', component.options)
    }
    module.hot.accept("./star-display.vue?vue&type=template&id=14792344&", function () {
      api.rerender('14792344', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2sOpPeBDeLKWt/JS/comp/star-display.vue"
export default component.exports